import { cn } from '@/util/cn';
import ToExternalPurchasePageButton from '@/components/region/LiftTicketTable/components/ToExternalPurchasePageButton';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import isLiftsUrlWhiteListed from '@/util/isLiftsUrlWhiteListed';

// Sits below the season-pass / daily-ticket pricing tables. Renders an
// optional "Special note" string, an optional "Purchase" CTA for partner
// resorts, and an always-visible last-updated disclaimer.
//
// All three slots are optional — when the resort has only a disclaimer
// the block degrades to a single italic line.

interface IProps {
  note: string | null;
  purchaseUrl?: string | null;
  disclaimer: string;
  isPartner: boolean;
}

const SpecialNote = ({
  note, purchaseUrl, disclaimer, isPartner,
}: IProps) => {
  const { t } = useOTSTranslation('common');
  const showButton = isPartner || isLiftsUrlWhiteListed(purchaseUrl);
  const showCard = !!note || showButton;

  return (
    <div className="mt-6 flex flex-col gap-3">
      {showCard && (
        <div
          className={cn(
            'flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between',
            note && 'rounded-md border border-primary p-3',
          )}
        >
          {note && (
            <p className="m-0 flex-1 text-sm italic">
              <strong className="not-italic">
                {t('resort.liftTickets.specialNote')}
                {': '}
              </strong>
              {note}
            </p>
          )}
          {showButton && (
            <ToExternalPurchasePageButton url={purchaseUrl || '/'} />
          )}
        </div>
      )}
      <p className="m-0 text-xs italic text-muted-foreground">{disclaimer}</p>
    </div>
  );
};

export default SpecialNote;
